<div *ngIf="this.loading || this.display" class="cssload-container">
    <div [ngClass]="{ 'cssload-speeding-wheel' : !this.isSmallSize , 'small-wheel' : this.isSmallSize }"></div>
</div>